module.exports = __webpack_public_path__ + "03_hair_gold.e9336d9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/03_hair_gold.png
// module id = tzJy
// module chunks = 0